export default __webpack_public_path__ + "static/media/file15.4201b34b.jpg";